// locale.service.ts
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LikutWarehouseService } from './likut-warehouse.service';

export type Locales = 'he-IL' | 'ar-IL';
export type LocalesEnum = '0' | '1' | '2';

export const LOCALE_PREFERENCE = {
	HEBREW: '0',
	DISPLAY_BOTH: '1',
	ARABIC: '2',
} as const;

export const LOCALES: Record<LocalesEnum, Locales> = {
	'0': 'he-IL',
	'1': 'he-IL',
	'2': 'ar-IL',
};

@Injectable({
	providedIn: 'root',
})
export class LocaleService {
	private localeSubject$ = new BehaviorSubject<Locales | null>((localStorage.getItem('LOCALE_ID') as Locales) ?? 'he-IL');
	locale$ = this.localeSubject$.asObservable();

	setLocale(locale: Locales | null) {
		this.localeSubject$.next(locale);
		if (!locale) {
			localStorage.removeItem('LOCALE_ID');
			location.reload();
			return;
		}
		localStorage.setItem('LOCALE_ID', locale);
		location.reload();
	}

	toggleLocale() {
		this.setLocale(this.localeSubject$.value === 'he-IL' ? 'ar-IL' : 'he-IL');
	}

	getLocale() {
		return this.localeSubject$.value;
	}
}
